import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { undefinedIfNullOrWhiteSpace } from "../../../../shared/utils/string";

// eslint-disable-next-line no-undef
import labels from "../../shared/labels";
import { computed, type PropType } from "vue";
import { type Setup, type AuctionProduct, type PhoneValidation } from "./types";
import CountdownComponent from "./countdown.vue";
import BidForm from "./bid-form.vue";
import BuyNowForm from "./buy-now-form.vue";
import { createCurrencyFormatter } from "../common/amount-format";
import FadeAndSlide from "../../shared/FadeAndSlide.vue";
import { isValidSecondsleft } from "../../../commons/product/auction/countdown";
import { type OverwriteSettings } from "../../../commons/product/overwrite-settings";


export default /*@__PURE__*/_defineComponent({
  __name: 'specs',
  props: {
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
    setup: {
        type: Object as PropType<Setup>,
        required: true,
    },
    overwriteSettings: Object as PropType<OverwriteSettings>,
    phoneValidation: Object as PropType<PhoneValidation>,
},
  setup(__props) {

const formatter = createCurrencyFormatter();

const props = __props;

const openForBid = computed(
    () =>
        props.product.hasAuction &&
        props.product.openForBid &&
        props.product.timeIsNotStarted === false &&
        props.product.timeTotalSeconds > 0
);

const showBidForm = computed(
    () => props.product.hasAuction && openForBid.value
);
const showBuyNowForm = computed(
    () => props.product.hasBuyNow || props.product.hasLoserOffer
);

function withTrailing(value: string | null | undefined, trail: string) {
    if (value == null) return value;
    return value + trail;
}

function formatAmounts(value: number) {
    return formatter.format(value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['specs-component'])
  }, [
    (_unref(isValidSecondsleft)(props.product.timeTotalSeconds))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style['countdown-container'])
        }, [
          _createVNode(CountdownComponent, {
            class: _normalizeClass(_ctx.$style['countdown-component']),
            "time-is-not-started": __props.product.timeIsNotStarted,
            "seconds-left": __props.product.timeTotalSeconds
          }, null, 8 /* PROPS */, ["class", "time-is-not-started", "seconds-left"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (__props.product.hasAuction)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
                _ctx.$style['bid-container'],
                __props.product.winningBid?.currentUser == true
                    ? _ctx.$style['current-user-highest-bid']
                    : '',
                !showBuyNowForm.value && !showBidForm.value ? _ctx.$style['nothing-below'] : '',
            ])
        }, [
          (__props.product.bidders > 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.$style['total-bidders'])
              }, [
                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.auction.totalBidders) + ": ", 1 /* TEXT */),
                _createElementVNode("strong", null, _toDisplayString(__props.product.bidders), 1 /* TEXT */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (__props.product.winningBid != null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.$style['highest-bidder'])
              }, [
                _createTextVNode(_toDisplayString(_unref(labels).frontendProductpage.auction[
                        __props.product.winningBid.currentUser
                            ? "highestBidderCurrentUser"
                            : "highestBidder"
                    ]) + " ", 1 /* TEXT */),
                _createElementVNode("strong", null, _toDisplayString(__props.product.winningBid.name), 1 /* TEXT */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['amounts'])
          }, [
            (__props.product.currentBid != null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style['bid-amount'])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style['bid-amount-header'])
                  }, _toDisplayString(__props.product.winningBid == null
                                ? _unref(labels).frontendProductpage.auction
                                      .minimumPrice
                                : _unref(labels).frontendProductpage.auction.currentBid) + ": ", 3 /* TEXT, CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style['bid-amount-value'])
                  }, _toDisplayString(formatAmounts(__props.product.currentBid)), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (
                        __props.product.showEstimatedPrice &&
                        __props.product.estimatedPrice != null
                    )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.$style['estimated-price'])
                }, _toDisplayString(withTrailing(
                            _unref(undefinedIfNullOrWhiteSpace)(
                                __props.overwriteSettings?.overwriteEstimateLabel
                            ),
                            ":"
                        ) ??
                        _unref(labels).frontendProductpage.specs
                            .shopEstimatedProductPrice) + " " + _toDisplayString(formatAmounts(__props.product.estimatedPrice)), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (showBidForm.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style['bid-form-container'])
            }, [
              _createVNode(BidForm, {
                product: __props.product,
                setup: __props.setup,
                "phone-validation": __props.phoneValidation
              }, null, 8 /* PROPS */, ["product", "setup", "phone-validation"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    (showBidForm.value && showBuyNowForm.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.$style['hr'])
        }, null, 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (showBuyNowForm.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(_ctx.$style['buy-now-container'])
        }, [
          _createVNode(BuyNowForm, { product: __props.product }, null, 8 /* PROPS */, ["product"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})